/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Transworld {
    'use strict';

    export class TransworldContext extends Meevo.Components.CommonClasses.CommonContextBase {

        public sectionsSecurityKeysBase: Array<string> = [
            this.securityKeys.INTEGRATION_TRANSWORLD_TAB_MAIN
        ];

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected transworldService: Meevo.Plugins.Transworld.TransworldService,
            protected $scope: angular.IScope,
            protected $mdDialog: ng.material.IDialogService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.transworld;
            this.sectionTemplatePath = 'app/plugins/transworld/sectionViews/';

            this.initializeSections();
        }

        initializeSections(): void {
            let baseSectionProps: ISectionParamsTransworld = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: false,
                handlesOwnCrud: true,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                transworldService: this.transworldService,
                context: this,
                identityService: this.identityService,
                busyService: this.busyService,
                noun: Meevo.Model.NounEnum.Transworld,
                sectionSecurityKey: ''
            }

            // Todo: changed security Keys for real one
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_TRANSWORLD_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(_.extend({}, baseSectionProps,
                    {
                        displayNameContentKey: 'SECTION_MAIN',
                        template: 'main.html',
                        isPrimarySection: true,
                        handlesOwnCrud: false,
                        sectionEndpoint: '',
                        sectionSecurityKey: this.securityKeys.INTEGRATION_TRANSWORLD_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    }), this.modalService));
            }

            this.activate();
        }        

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        save(): angular.IPromise<any> {
            let selectedSection = <any>this.selectedSection;

            if (selectedSection.saveData && _.isFunction(selectedSection.saveData)) {
                return selectedSection.saveData();
            }

            return super.save();
        }

        selectSection(item): void {
            super.selectSection(item);

            this.buildCrudSecurityKeysBase(this.sectionsSecurityKeysBase[item.sectionId]);

            if (item.getData && _.isFunction(item.getData)) {
                item.getData();
            }
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;

        }
    }
}
